<template>
  <v-container fluid class="user-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">User Information</v-stepper-step>

              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">User Details</v-stepper-step>

            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New User</p>
                        <v-text-field
                          class="mb-4"
                          v-model="user.username"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="User Name"
                          persistent-hint
                          single-line hint="Enter the user name">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user.userid"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="User Id"
                          persistent-hint
                          single-line hint="Enter the user id">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user.useremail"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Email Address"
                          persistent-hint
                          single-line hint="Enter the user email address">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="user.userpassword"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Password"
                          persistent-hint
                          single-line hint="Enter user password. Min 6 characters long">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="user.usertype"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the user type">
                        </v-select>
                          <v-switch
                            v-model="user.userstatus"
                            color="primary"
                            v-bind:label="user.userstatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/user/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createUser()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      user: {
        userid: '',
        username: '',
        useremail: '',
        userpassword: '',
        usertype: '',
        userstatus: 'Active',
        userimage: undefined,
        imagename: ''
      },
      items: ['System Administrator', 'Company Administrator', 'Sales Representative'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('User', [
      'createUserRequest',
      'getUsersRequest'
    ]),
    checkError(){
      if(!this.user.username){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.user.userid){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.user.useremail){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.user.userpassword || this.user.userpassword.length<6){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.user.usertype){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createUser() {
      this.createUserRequest(this.user)
      this.getUsersRequest()
      router.push('/user/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.user.userimage = file;
      this.user.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('User', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
